import { AuthContext } from 'context/AuthContext';
import { useContext } from 'react';
import { useLocation } from 'react-router-dom';
import { UIElementProps } from 'types/prop-types';
import '../../assets/styles/base.scss';
import { SimpleHeader } from './SimpleHeader';
import { useActivePhases } from 'hooks/useControlDate';
import { PRODUTO_CONFIG } from 'config/produto';

export function AppContainer({ children }: UIElementProps) {
    const { isAuthenticated, user } = useContext(AuthContext);
    const location = useLocation();
    const userName = user?.name ? user.name.split(" ")[0] : '';
    const phases = useActivePhases();

    const shouldShowSimpleHeader =
      PRODUTO_CONFIG.shouldShowSimpleHeader(phases, location.pathname) && isAuthenticated;

    return (
      <div className="flex flex-col w-full min-h-screen">
        <>
          {shouldShowSimpleHeader && (
            <SimpleHeader title={PRODUTO_CONFIG.titulo} userName={userName} />
          )}
          <div className={isAuthenticated ? "" : ""}>
            <div className={isAuthenticated ? "" : ""}>{children}</div>
          </div>
        </>
      </div>
    );
}
